<template>
  <div class="" style="margin: 0">

    <custom-hero title="Something went wrong." :descriptionText="desc">

    </custom-hero>

  </div>
</template>
<script>
import CustomHero from "@/views/Components/CustomHero";
export default {
  components: { CustomHero},
  props: {
    // desc: {
    //   type: String,
    //   default: "The page you are looking for does not exist.",
    //   description: "error description",
    // },
  },
  data() {
    return {
      desc: "The page you are looking for does not exist.",
      showModal: false
    }
  },
  mounted() {
    // eslint-disable-next-line no-prototype-builtins
    if(this.$route.params.hasOwnProperty("desc")) {
      this.desc = this.$route.params.desc
    }
  }
}
</script>